interface Props {
  cartItemBundleId: number;
  cartItemId: number;
  noOptionSelectedIntially?: boolean;
}

export const useSelectNumberConfig = (props: Props) => {
  const store = useMyCheckoutStore();
  const showNumberPublicly = ref(false);

  const numberConfig = computed(() => {
    const keyForThisNumberConfigInMap =
      checkoutStore_createNumberSelectionMapKey(
        props.cartItemBundleId,
        props.cartItemId,
      );
    return store.userState.numberConfigMap[keyForThisNumberConfigInMap];
  });

  const cartItem = computed(() =>
    store.fetchedData.cart.cartItems?.find(
      (item) => item.BundleId === props.cartItemBundleId,
    ),
  );

  const esimRequired = computed(() => cartItem.value?.EsimRequired ?? false);
  const esimSupported = computed(() => cartItem.value?.EsimSupported ?? false);
  const isEsim = esimRequired.value ? ref(true) : ref(false);

  if (props.noOptionSelectedIntially) {
    numberConfig.value.keepNumberOption = undefined;
  }

  const hasNotValidated = computed(
    () => !numberConfig.value.keepNumberCodeValidated,
  );

  const codeHasBeenSentButNotValidated = computed(
    () =>
      numberConfig.value.keepNumberCodeSent &&
      !numberConfig.value.keepNumberCodeValidated,
  );

  const codeHasBeenSentAndCodeInputHasValue = computed(
    () =>
      numberConfig.value.keepNumberCodeSent &&
      numberConfig.value.keepNumberCodeInputValue,
  );

  const reset = () => {
    numberConfig.value.keepNumberInputValue = '';
    numberConfig.value.keepNumberCodeSent = false;
    numberConfig.value.keepNumberCodeInputValue = '';
    numberConfig.value.keepNumberCodeValidated = false;
  };

  watch(
    showNumberPublicly,
    (value: boolean) => {
      if (numberConfig.value) {
        numberConfig.value.hiddenNumber = !value;
      }
    },
    { immediate: true },
  );
  watch(
    isEsim,
    (value: boolean) => {
      numberConfig.value.esim = cartItem.value?.EsimRequired ? true : value;
    },
    { immediate: cartItem.value?.EsimRequired ? true : false },
  );

  return {
    codeHasBeenSentAndCodeInputHasValue,
    codeHasBeenSentButNotValidated,
    esimRequired,
    esimSupported,
    hasNotValidated,
    isEsim,
    numberConfig,
    reset,
    showNumberPublicly,
  };
};
